import { render } from "./MessageAccueilJournee.vue?vue&type=template&id=7587e6e1&scoped=true"
import script from "./MessageAccueilJournee.vue?vue&type=script&lang=js"
export * from "./MessageAccueilJournee.vue?vue&type=script&lang=js"

import "./MessageAccueilJournee.vue?vue&type=style&index=0&id=7587e6e1&lang=scss&scoped=true"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7587e6e1"]])

export default __exports__